import type { ReactNode } from 'react';

import { Heading } from '@/components/ui/heading';

/** A small uppercase label that opens a group within a step, such as Research or a list of points. */
export function SectionHeading({ children }: { children: ReactNode }) {
  return (
    <Heading size="h3-xs" className="font-semibold uppercase text-typography-700">
      {children}
    </Heading>
  );
}
